import { Box } from "@material-ui/core";
import React from "react";
import ReactList from "react-list";
import { FlightFare, IFlightListData } from "redmond";
import { RecommendedFlightInfo } from "../RecommendedFlightInfo";
import { RecommendedFlightInfoProps } from "../RecommendedFlightInfo/component";
import { FlightSummaryPanel } from "../../../FlightShopHeader/FlightSummaryPanel";
import { SelectedPackagePricingCard } from "../../../FlightShopHeader/SelectedPackagePricingCard";
import { FlightShopHeader } from "../../../FlightShopHeader";
import { FlightListInfo } from "../FlightListInfo";

interface MobileFlightListProps
  extends Omit<RecommendedFlightInfoProps, "flight" | "selectedFare"> {
  faresToShow: IFlightListData[];
  flights: any;
  selectedFareId: string;
  isOutgoing: boolean;
  outgoingRecommendedFlight: any;
  returnRecommendedFlight: IFlightListData | null | undefined;
  isXmodRedesign?: boolean;
}

export const MobileFlightList = ({
  isOutgoing,
  faresToShow,
  flights,
  selectedFareId,
  outgoingRecommendedFlight,
  returnRecommendedFlight,
  expandedFlight,
  maxPriceFilter,
  packageNightCountBasedOnAvailability,
  packageNightCountBasedOnOutboundFlight,
  packagesByOutboundFareSlice,
  packagesByReturnFareSlice,
  fareClassFilter,
  isAgentPortal,
  departureDate,
  returnDate,
  hotelShopDateRange,
  airports,
  rewardsKey,
  isTripDetailsLoading,
  expandedFareDetails,
  handleClickAlgomerchTag,
  setOpenModal,
  handleFareSelect,
  setClickedFareId,
  setExpandedFlight,
  handleSliceSelect,
  isXmodRedesign,
  selectedRewardsAccount,
  canEarnRewards,
}: MobileFlightListProps) => {
  const getSelectedFare = (flight: any, selectedFareId: string): unknown => {
    return (
      flight?.fares.find(
        (fare: any) => fare?.example?.fare === selectedFareId,
      ) || flight?.fares[0]
    );
  };

  const recommendedFlight = isOutgoing
    ? outgoingRecommendedFlight
    : returnRecommendedFlight;
  const selectedRecommendedFare = getSelectedFare(
    recommendedFlight,
    selectedFareId,
  ) as any;

  const renderListItem = React.useCallback(
    (index: number, key: number | string) => {
      const currentFare = faresToShow[index];

      const { slice: flightSliceId } = currentFare;
      const flightSlice = flights?.slices[flightSliceId];
      const isListView = !flightSlice?.domestic;
      if (
        !flightSlice ||
        flightSliceId === outgoingRecommendedFlight?.slice ||
        flightSliceId === returnRecommendedFlight?.slice
      ) {
        // itemRenderer does not allow for returning of undefined/null
        return (
          <Box
            display="none"
            // key={`${fare.example?.fare || fare.id}-none`}
          />
        );
      }
      const selectedFare = getSelectedFare(
        currentFare,
        selectedFareId,
      ) as FlightFare;

      return (
        <FlightListInfo
          key={key}
          selectedFare={selectedFare}
          selectedFareId={selectedFareId}
          showListView={isListView}
          slice={flightSlice}
          flight={currentFare}
          index={index}
          flights={flights}
          expandedFlight={expandedFlight}
          fareClassFilter={fareClassFilter}
          maxPriceFilter={maxPriceFilter}
          isOutgoing={isOutgoing}
          packageNightCountBasedOnAvailability={
            packageNightCountBasedOnAvailability
          }
          packageNightCountBasedOnOutboundFlight={
            packageNightCountBasedOnOutboundFlight
          }
          packagesByOutboundFareSlice={packagesByOutboundFareSlice}
          packagesByReturnFareSlice={packagesByReturnFareSlice}
          departureDate={departureDate}
          returnDate={returnDate}
          hotelShopDateRange={hotelShopDateRange}
          isTripDetailsLoading={isTripDetailsLoading}
          airports={airports}
          rewardsKey={rewardsKey}
          isAgentPortal={isAgentPortal}
          selectedRewardsAccount={selectedRewardsAccount}
          canEarnRewards={canEarnRewards}
          expandedFareDetails={expandedFareDetails}
          handleClickAlgomerchTag={handleClickAlgomerchTag}
          setOpenModal={setOpenModal}
          handleSliceSelect={handleSliceSelect}
          setClickedFareId={setClickedFareId}
          setExpandedFlight={setExpandedFlight}
          handleFareSelect={handleFareSelect}
          isXmodRedesign={isXmodRedesign}
        />
      );
    },
    [
      faresToShow,
      flights,
      selectedFareId,
      expandedFlight,
      fareClassFilter,
      maxPriceFilter,
      isOutgoing,
      packagesByOutboundFareSlice,
      packagesByReturnFareSlice,
      departureDate,
      returnDate,
      hotelShopDateRange,
      isTripDetailsLoading,
      airports,
      rewardsKey,
      isAgentPortal,
      selectedRewardsAccount,
      canEarnRewards,
      expandedFareDetails,
    ],
  );

  return (
    <div className="availability-list">
      <FlightSummaryPanel />
      <Box className="selected-package-pricing-card-wrapper">
        <SelectedPackagePricingCard isMobile />
      </Box>
      <FlightShopHeader isMobile />

      <RecommendedFlightInfo
        flight={
          isOutgoing ? outgoingRecommendedFlight : returnRecommendedFlight
        }
        flights={flights}
        selectedFare={selectedRecommendedFare}
        selectedFareId={selectedFareId}
        expandedFlight={expandedFlight}
        maxPriceFilter={maxPriceFilter}
        isOutgoing={isOutgoing}
        packageNightCountBasedOnAvailability={
          packageNightCountBasedOnAvailability
        }
        packageNightCountBasedOnOutboundFlight={
          packageNightCountBasedOnOutboundFlight
        }
        packagesByOutboundFareSlice={packagesByOutboundFareSlice}
        packagesByReturnFareSlice={packagesByReturnFareSlice}
        fareClassFilter={fareClassFilter}
        isAgentPortal={isAgentPortal}
        departureDate={departureDate}
        returnDate={returnDate}
        hotelShopDateRange={hotelShopDateRange}
        airports={airports}
        rewardsKey={rewardsKey}
        isTripDetailsLoading={!!isTripDetailsLoading}
        selectedRewardsAccount={selectedRewardsAccount}
        canEarnRewards={canEarnRewards}
        expandedFareDetails={expandedFareDetails}
        handleClickAlgomerchTag={handleClickAlgomerchTag}
        setOpenModal={setOpenModal}
        handleFareSelect={handleFareSelect}
        setClickedFareId={setClickedFareId}
        setExpandedFlight={setExpandedFlight}
        handleSliceSelect={handleSliceSelect}
        isXmodRedesign={isXmodRedesign}
      />
      <ReactList
        itemRenderer={renderListItem}
        length={faresToShow.length}
        type="variable"
      />
    </div>
  );
};
